import axios,{post,get} from "axios";
//import FormData from "form-data";
import {AdminMmscmCSVUploadEndPoint, AdminBannerUpdateEndPoint, AdminBannerGetEndPoint} from "../../../config/AppServerConfig";
import {GlobalConfig} from "../../../Services/Helper/GlobalConfig";

// axios.interceptors.response.use((response) => {
//     return response;
// }, function (error) {
//     return Promise.reject(error.response);
// });

class MmscmFileUploadServices {
    static csvUpload(file) {

        const config = {
            headers: {"Authorization": GlobalConfig.Token,
            'content-type': 'multipart/form-data'}
        };
        return post(AdminMmscmCSVUploadEndPoint,file, config);
    }

}
class BannerServices {
    static bannerUpdate(data) {

        const config = {
            headers: {"Authorization": GlobalConfig.Token}
        };
        return post(AdminBannerUpdateEndPoint,data, config);
    }
    static getBanner() {

        const config = {
            headers: {"Authorization": GlobalConfig.Token}
        };
        return get(AdminBannerGetEndPoint, config);
    }

}
export {MmscmFileUploadServices, BannerServices};
